__turbopack_context__.v({
  "image": "RjXQIa_image",
  "imageLoaded": "RjXQIa_imageLoaded",
  "imageLoading": "RjXQIa_imageLoading",
  "imageWrapper": "RjXQIa_imageWrapper",
  "placeholder": "RjXQIa_placeholder",
});
